import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-white p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-400 mb-8">
          <ArrowLeft size={20} />
          Back to Studio
        </Link>
        
        <img 
          src="https://customer-assets.emergentagent.com/job_ai-command-hub-48/artifacts/opkezy5x_CB3D4111-0127-441A-AEB4-FB146D6CBB1E.PNG" 
          alt="IPVALUE Managements"
          className="h-20 mb-8"
        />
        
        <h1 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Terms of Service
        </h1>
        
        <p className="text-zinc-400 mb-4">Last updated: March 2024</p>
        
        <div className="prose prose-invert max-w-none space-y-6 text-zinc-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using IPVALUE AI Studio ("the Service"), operated by IPVALUE Managements Group, 
              you agree to be bound by these Terms of Service. If you do not agree to these terms, 
              please do not use the Service.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">2. Description of Service</h2>
            <p>
              IPVALUE AI Studio is a content creation and management platform designed for the 
              IPVALUE Digital Business Academy. The Service provides tools for lesson creation, 
              social media management, marketing funnel building, and educational content distribution.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">3. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials 
              and for all activities that occur under your account. You agree to notify us immediately 
              of any unauthorized use of your account.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">4. Content Ownership</h2>
            <p>
              You retain ownership of all content you create using the Service. By using the Service 
              to post content to third-party platforms (such as TikTok, Instagram, YouTube, etc.), 
              you agree to comply with those platforms' terms of service.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">5. Acceptable Use</h2>
            <p>You agree not to use the Service to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Create or distribute harmful, illegal, or misleading content</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on the intellectual property rights of others</li>
              <li>Spam or engage in unauthorized advertising</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">6. Third-Party Integrations</h2>
            <p>
              The Service integrates with third-party platforms including but not limited to TikTok, 
              Instagram, YouTube, Facebook, LinkedIn, ElevenLabs, and Whop. Your use of these 
              integrations is subject to the respective terms of service of each platform.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">7. Limitation of Liability</h2>
            <p>
              IPVALUE Managements Group shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages resulting from your use of the Service.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of the Service 
              after changes constitutes acceptance of the modified terms.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">9. Contact</h2>
            <p>
              For questions about these Terms of Service, please contact us at:<br />
              <strong>IPVALUE Managements Group</strong><br />
              Email: support@ipvaluemanagements.com
            </p>
          </section>
        </div>
        
        <div className="mt-12 pt-8 border-t border-zinc-800 text-center text-zinc-500 text-sm">
          © 2024 IPVALUE Managements Group. All rights reserved.
        </div>
      </div>
    </div>
  );
}
